"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _material = require("@mui/material");

var _IconButton = require("../IconButton");

var _MenuItem = require("../MenuItem");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["type", "label", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var NavMenu = function NavMenu(props) {
  var _props$items;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var handleClick = function handleClick(e) {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var renderItems = function renderItems(_ref) {
    var type = _ref.type,
        _ref$label = _ref.label,
        label = _ref$label === void 0 ? "" : _ref$label,
        _onClick = _ref.onClick,
        rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);

    switch (type) {
      case "option":
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.MenuItem, _objectSpread({
          label: label,
          onClick: function onClick(e) {
            if (_onClick) {
              _onClick(e);
            }

            handleClose();
          }
        }, rest));

      case "divider":
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Divider, _objectSpread({}, rest));

      default:
        return null;
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
    mr: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.IconButton, {
      "aria-label": props["aria-label"],
      borderless: true,
      iconName: "chevron-down",
      onClick: handleClick,
      size: "small",
      sx: {
        backgroundColor: function backgroundColor(theme) {
          return anchorEl ? theme.palette.primary.light : undefined;
        }
      },
      "data-cy": props["data-cy"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Menu, {
      anchorEl: anchorEl,
      anchorOrigin: {
        horizontal: "right",
        vertical: "top"
      },
      elevation: 2,
      id: "nav-menu",
      keepMounted: true,
      onClose: handleClose,
      open: Boolean(anchorEl),
      style: {
        marginTop: "2rem"
      },
      transformOrigin: {
        horizontal: "right",
        vertical: "top"
      },
      variant: "menu",
      children: (_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.map(function (item) {
        return renderItems(item);
      })
    })]
  });
};

var _default = NavMenu;
exports.default = _default;